import { Page } from '@models/page';
import { RuntimeVariable } from '@models/runtime-variable.model';
import api from '../api/instance';
import { PrivateURLConstants } from '@constants/private-url.constant';

const nameSpace = PrivateURLConstants.STEP_RUNTIME_VARIABLES;

const findAll = (query?, size?, page?, sort?) => {
  return api
    .get(nameSpace, {
      query,
      size,
      page,
      sort,
    })
    .then((res) => {
      return new Page<RuntimeVariable>().deserialize(res, RuntimeVariable);
    })
    .catch((e) => {
      throw e;
    });
};

export const RuntimeVariableService = {
  findAll,
};
